import Vue from 'vue'
import selectInput from './common/selectInput'
import rangePicker from './common/rangePicker'
import xTable from './common/xTable'
import xTableColumn from './common/xTableColumn'
import selectPopover from './common/selectPopover'
import addressSelect from './common/addressSelect'
Vue.component('select-input', selectInput);
Vue.component('range-picker', rangePicker);
Vue.component('x-table', xTable);
Vue.component('x-table-column', xTableColumn);
Vue.component('select-popover', selectPopover);
Vue.component('address-select', addressSelect);